// cf https://github.com/facebook/docusaurus/blob/main/packages/docusaurus-theme-common/src/utils/reactUtils.tsx
// todo: message not printed

/**
 * This error is thrown when a context is consumed outside its provider. Allows
 * reusing a generic error message format and reduces bundle size. The hook's
 * name will be extracted from its stack, so only the provider's name is needed.
 */
export class ReactContextError extends Error {
    constructor(providerName: string, additionalInfo?: string) {
        super()
        this.name = 'ReactContextError'
        this.message = `Hook ${
            this.stack?.split('\n')[1]?.match(/at (?:\w+\.)?(?<name>\w+)/)?.groups?.name ?? ''
        } is called outside the <${providerName}>. ${additionalInfo ?? ''}`
    }
}
